import axios from 'axios';
import { AppSettings } from '../../configs';
import { authHeader } from '../../helpers/auth-header';

export function getChangeCommitteeAllAction(po_no,user_code) {
  return  function (dispatch) {
    try {
        let promise=  axios({
            headers: authHeader(),
            method: "get",
            url: `${AppSettings.apiUrl}/api/ChangeCommittee/GetChangeCommitteeAll`,
            params: {
              po_no: po_no
              ,user_code:user_code
            }
        })

        return promise
    } catch (error) {

    }
}

}